import IconDots from '../../../assets/dots.png'
import ArrowNext from '../../../assets/arrowNext.png'
import IconPencil from '../../../assets/pencil-01.png'
import { ButtonDropdown } from 'components/molecules/ButtonDropdown/ButtonDropdown'
import IconTrash from '../../../assets/trash.png'
import AppModalConfirmation from 'components/atoms/AppModalConfirmation/AppModalConfirmation'
import { useState } from 'react'
import { usePermissions } from 'hooks/usePermissions'
import { RolePermissions } from 'utils/constants'

interface Props {
    id: number
    title: string
    countRules: number
    countChutes: number
    nameWarehouse?: string
    onSubmit?: () => void
    deletePattern: () => void
    editPattern: () => void
}
export default function PatternCardItem({
    id,
    title,
    countRules,
    countChutes,
    onSubmit,
    deletePattern,
    editPattern,
    nameWarehouse,
}: Props) {
    const [confirmModal, setConfirmModal] = useState(false)
    const { can } = usePermissions()
    const handleDeletePattern = () => {
        setConfirmModal(false)
        deletePattern()
    }
    const canEdit = can(RolePermissions.templates.edit)
    const canDelete = can(RolePermissions.templates.delete)

    const dropdownOptions = [
        ...(canDelete
            ? [
                  {
                      title: 'Eliminar',
                      icon: IconTrash,
                      onClick: () => setConfirmModal(true),
                  },
              ]
            : []),
        ...(canEdit
            ? [
                  {
                      title: 'Editar',
                      icon: IconPencil,
                      onClick: () => editPattern(),
                  },
              ]
            : []),
    ]
    const hasDropdownOptions = dropdownOptions.length > 0
    return (
        <div
            onClick={(e) => {
                if (!confirmModal && onSubmit) {
                    onSubmit()
                } else {
                    e.stopPropagation()
                    setConfirmModal(false)
                }
            }}
            className="w-full border border-[#CBD5E1] hover:border-[#1F2531] cursor-pointer transition-colors duration-200 flex justify-between items-center px-4 py-4 bg-white rounded-xl mb-4"
        >
            <AppModalConfirmation
                title={'Eliminar Plantilla ' + id}
                description={
                    '¿Estás seguro de que deseas eliminar esta plantilla? Esta acción no se puede deshacer.'
                }
                onClose={() => setConfirmModal(false)}
                handleConfirm={() => handleDeletePattern()}
                isOpen={confirmModal}
            />
            <div className="text-left">
                <div className="flex items-center">
                    <h2 className="font-semibold text-base text-[#141A1F]">
                        {title}
                    </h2>
                    <div className="ml-5" onClick={(e) => e.stopPropagation()}>
                        {hasDropdownOptions && (
                            <ButtonDropdown
                                options={dropdownOptions}
                                color="primary"
                                imageSrc={IconDots}
                            />
                        )}
                    </div>
                </div>
                <div className="flex mt-1">
                    <h3 className="text-sm font-normal text-[#3E5060]">
                        {countRules} Reglas
                    </h3>
                    <div className="w-px h-4 bg-gray-300 mx-3" />
                    <h3 className="text-sm font-normal text-[#3E5060]">
                        {countChutes} Asignados
                    </h3>
                    <div className="w-px h-4 bg-gray-300 mx-3" />
                    {nameWarehouse && (
                        <h3 className="text-sm font-normal text-[#3E5060]">
                            Warehouse: {nameWarehouse}
                        </h3>
                    )}
                </div>
            </div>
            <img className="mr-3" src={ArrowNext} alt="ArrowNext" />
        </div>
    )
}
